import { render, staticRenderFns } from "./Crews.vue?vue&type=template&id=15a36db3&scoped=true"
import script from "./Crews.vue?vue&type=script&lang=js"
export * from "./Crews.vue?vue&type=script&lang=js"
import style0 from "./Crews.vue?vue&type=style&index=0&id=15a36db3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a36db3",
  null
  
)

export default component.exports